import React, { useState, useEffect } from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import api from '../api/axiosConfig';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const KendaraanDinasChart = () => {
  const [chartData, setChartData] = useState({
    labels: [],
    datasets: [],
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchChartData = async () => {
      try {
        const { data } = await api.get('/api/dashboard/kendaraan-dinas-chart');
        setChartData({
          labels: data.labels,
          datasets: [
            {
              label: 'Jumlah Kendaraan',
              data: data.data,
              backgroundColor: 'rgba(75, 192, 192, 0.6)', // Warna hijau toska
              borderColor: 'rgba(75, 192, 192, 1)',
              borderWidth: 1,
            },
          ],
        });
      } catch (error) {
        console.error("Gagal mengambil data chart Kendaraan Dinas:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchChartData();
  }, []);

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: true,
        text: 'Jumlah Pengguna Kendaraan per Jabatan',
        font: {
            family: 'Poppins',
            size: 16,
        },
        color: '#333'
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
            stepSize: 1
        }
      },
    },
  };

  if (loading) {
    return <p>Memuat data grafik...</p>;
  }

  return <Bar options={options} data={chartData} />;
};

export default KendaraanDinasChart;